import {searchModel} from "../../../../Utilities/Search";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {dynamicSort} from "../../../../Utilities/Sort";

export const ownLoanSearchModel = (pageId = "", patronId = "", shippingLocationId = "", districtId = "", organization = "") => {
    return Object.assign({}, searchModel(pageId.toString(), "shippingLocationName", false, "shippingLocationName"), {
        shippingLocationId,
        patronId,
        districtId,
        organization,
        ClearOrderSearch: clearOrderSearch,
        ApplySorting: applySorting,
    });
};

function clearOrderSearch(this: Record<string, unknown>) {
    this.shippingLocationId = "";
    this.patronId = "";
    this.districtId = "";
    this.organization = "";
    (this as { ClearSearch: (load: boolean) => void }).ClearSearch(false);
}

function applySorting(loanSearchCriteria: Record<string, any>, loans: Record<string, any>[]) {
    if (isNullOrUndefined(loans) || isArrayNullOrEmpty(loans))
        return loans;

    return loans.sort(dynamicSort(loanSearchCriteria.sortByColumn as string, loanSearchCriteria.sortDescending as boolean));
}
